import { useContext, useState } from 'react';
import { useMutation } from '@apollo/client/react';

import UserGroupContext from '@atom/components/userGroupDetail/UserGroupContext';
import { UPDATE_USER_GROUP } from '@atom/graph/userGroup';
import { Button, Icon, IconButton, Progress, TextField } from '@atom/mui';
import { EditIcon } from '@atom/mui/icons';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

import classes from './userGroupInfo.module.css';

const DescriptionSection = () => {
  const { userGroup } = useContext(UserGroupContext);

  const [editMode, setEditMode] = useState<boolean>(false);
  const [description, setDescription] = useState<string>(userGroup.description);

  const [updateUserGroup, { loading }] = useMutation(UPDATE_USER_GROUP);

  const confirm = () => {
    updateUserGroup({
      variables: {
        input: {
          id: userGroup.id,
          description,
        },
      },
    });

    setEditMode(false);
  };

  const onCancel = () => {
    setEditMode(false);
    setDescription(userGroup.description);
  };

  const rightButtons = editMode ? (
    <div>
      <Button onClick={onCancel} disabled={loading}>
        Cancel
      </Button>
      <Button color="primary" onClick={confirm} disabled={loading}>
        Save
      </Button>
      {loading && (
        <div className={classes.spinnerContainer}>
          <Progress size={25} thickness={2} />
        </div>
      )}
    </div>
  ) : hasRolePermissions(ROLE_SETS.ORG_ADMIN) ? (
    <IconButton onClick={() => setEditMode(true)}>
      <Icon icon={EditIcon} />
    </IconButton>
  ) : (
    <div />
  );

  return (
    <>
      <div className={classes.titleContainer}>
        <div>Description</div>
        {rightButtons}
      </div>
      <div className={classes.contentContainer}>
        {editMode ? (
          <TextField
            multiline
            name="description"
            value={description}
            onChange={event => setDescription(event.target.value)}
          />
        ) : (
          <div>{userGroup.description}</div>
        )}
      </div>
    </>
  );
};

export default DescriptionSection;
